import { MatDialogConfig } from '@angular/material/dialog';
import { GusDialogConfig } from '../models/dialog.models';

export const DEFAULT_DIALOG_PANEL_CONFIG: MatDialogConfig = {
  width: '90%',
  maxWidth: '470px',
  maxHeight: '80vh',
  panelClass: 'gus-dialog-panel',
};

export const SUCCESS_CONFIG: Partial<GusDialogConfig> = {
  title: 'Success',
  body: 'Operation completed successfully',
  primaryButtonText: 'Close',
  hasSecondaryButton: false,
  hasCloseButton: false,
  hasPrimaryButton: true,
};

export const ERROR_CONFIG: Partial<GusDialogConfig> = {
  title: 'Error',
  body: 'Something went wrong',
  hasPrimaryButton: true,
  primaryButtonText: 'Got it!',
  hasSecondaryButton: false,
};
